module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_8004.7063c899.png";